import React from 'react'
import {
  CostItem,
  EstimatedFees,
  EstimatedProfit,
  SellingPrice,
} from '../../../../components/CostItem'
import * as S from './styled'
import type { Props } from './types'

export const AccordionPanel = ({
  cost,
  price,
  profit,
  feesValue,
  includeFeesValue,
  autoAdjustedSellingPrice,
}: Props) => {
  return (
    <S.Container>
      <SellingPrice value={price || 0} autoAdjusted={autoAdjustedSellingPrice} />
      <CostItem name="Manufacturing costs per item" value={cost || 0} negative />
      {includeFeesValue && <EstimatedFees value={feesValue} />}
      <EstimatedProfit value={profit} withSeparator={false} />
    </S.Container>
  )
}
